import script from "./availableCourses.vue?vue&type=script&setup=true&lang=js"
export * from "./availableCourses.vue?vue&type=script&setup=true&lang=js"

import "./availableCourses.vue?vue&type=style&index=0&id=fadee938&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fadee938"]])

export default __exports__